
<app-common-modal #modal
  [modalClass]="{'media-gallery-modal': true}"
  [commonModalConfig]="{header: true, body: true, footer: true}"
  [config]="{
    size: 'lg',
    modalDialogClass: 'invisible-container'
  }">
  <ng-container ModalHeader>
    <h3 class="m-0">{{modalTitle |translate}}</h3>
    <!--begin::Close-->
    <app-icon-button
      title="close"
      [iconOnly]="true"
      iconType="fa-solid"
      iconClass="fa-xmark text-primary"
      (click)="modal.close(null)"
    ></app-icon-button>
    <!--end::Close-->
  </ng-container>
  <ng-container ModalBody>
    <app-upload-image-list
      [mediaList]="mediaList">
    </app-upload-image-list>
  </ng-container>
</app-common-modal>
